/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_sku = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingHolidayDelivery_sku">;
    readonly " $refType": "PdpRespSidebarBlurbShipping_sku";
};
export type PdpRespSidebarBlurbShipping_sku$data = PdpRespSidebarBlurbShipping_sku;
export type PdpRespSidebarBlurbShipping_sku$key = {
    readonly " $data"?: PdpRespSidebarBlurbShipping_sku$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_sku">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbShipping_sku",
  "type": "ItemSkuType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingHolidayDelivery_sku",
      "args": null
    }
  ]
};
(node as any).hash = '0b39b2dde9ee83e734ff2726bfa413cd';
export default node;
